import React, { Component } from 'react';
import { connect } from 'react-redux';
import { findUser } from '../actions/users';
import {
  findSub as findSprintSub,
  fetchUpcomingPlan as fetchSprintUpcomingPlan,
} from '../actions/subs';
import {
  findAttSub,
  fetchUpcomingPlan as fetchAttUpcomingPlan,
} from '../actions/attSubs';
import { findTracfoneSub } from '../actions/tracfoneSubs';
import { findSimoSub } from '../actions/simoSubs';

import { fetchPlan } from '../actions/plans';
import { fetchAttPlan } from '../actions/attPlans';
import { findQuickSub } from '../actions/quickSubs';

import {
  withAttSub,
  withTracfoneSub,
  withSprintSub,
  withSimoSub,
  withQuickSub,
} from './withSub';
import getCarrier from '../helpers/getCarrier';
import { getSubStatus } from 'helpers/subs';

const subPage = (
  DecoratedComponent,
  findSub,
  fetchUpcomingPlan,
  fetchPlan,
  loadUpcomingDetails = true,
) => {
  class SubPage extends Component {
    componentDidMount() {
      this.fetchSub();
    }

    componentDidUpdate(oldProps) {
      if (oldProps.subId !== this.props.subId) {
        this.fetchSub();
      }

      if (
        loadUpcomingDetails &&
        this.props.upcomingPlanId &&
        oldProps.upcomingPlanId !== this.props.upcomingPlanId
      ) {
        this.props.fetchPlan && this.props.fetchPlan(this.props.upcomingPlanId);
      }
    }

    fetchSub() {
      const { findSub, fetchUpcomingPlan, subId, findUser } = this.props;
      findSub(subId).then(() => {
        const { sub } = this.props;
        if (sub) {
          findUser(sub.user_profile);

          const carrier = getCarrier(sub);
          const notExpired = getSubStatus(sub) !== 'expired';
          if ((carrier === 'sprint' || carrier === 'att') && notExpired) {
            fetchUpcomingPlan && fetchUpcomingPlan(subId);
          }
        }
      });
    }

    render() {
      const { children, findSub, findUser, ...props } = this.props;

      return React.createElement(DecoratedComponent, props, children);
    }
  }

  const mapDispatchToProps = {
    findSub,
    findUser,
    fetchUpcomingPlan,
    fetchPlan,
  };

  SubPage = connect(null, mapDispatchToProps)(SubPage);

  return SubPage;
};

export const attSubPage = (DecoratedComponent) =>
  withAttSub(
    subPage(DecoratedComponent, findAttSub, fetchAttUpcomingPlan, fetchAttPlan),
  );
export const attSubPageWithoutUpcommingPlan = (DecoratedComponent) =>
  withAttSub(subPage(DecoratedComponent, findAttSub, null, fetchAttPlan));
export const attSubPageWithoutPlan = (DecoratedComponent) =>
  withAttSub(
    subPage(DecoratedComponent, findAttSub, fetchAttUpcomingPlan, null),
  );
export const attSubWithoutPlans = (DecoratedComponent) =>
  withAttSub(subPage(DecoratedComponent, findAttSub, null, null));
export const attSubPageWithoutUpcomingDetails = (DecoratedComponent) =>
  withAttSub(
    subPage(
      DecoratedComponent,
      findAttSub,
      fetchAttUpcomingPlan,
      fetchAttPlan,
      false,
    ),
  );

export const tracfoneSubPage = (DecoratedComponent) =>
  withTracfoneSub(subPage(DecoratedComponent, findTracfoneSub));
export const sprintSubPage = (DecoratedComponent) =>
  withSprintSub(
    subPage(
      DecoratedComponent,
      findSprintSub,
      fetchSprintUpcomingPlan,
      fetchPlan,
    ),
  );
export const simoSubPage = (DecoratedComponent) =>
  withSimoSub(subPage(DecoratedComponent, findSimoSub));
export const quickSubPage = (DecoratedComponent) =>
  withQuickSub(subPage(DecoratedComponent, findQuickSub));

export default sprintSubPage;
